import { fetchProviderComments } from './fetch-comments-service.js'

export { fetchProviderComments }
